import React from 'react'
import { JobItemPlaceholer } from './JobItemPlaceholer'
import JobItemPlaceholderStyles from './JobItemPlaceholder.css'

const JOB_PER_PAGE: number = 10

export default class JobListPlaceholder extends React.PureComponent {
    render() {
        const jobListNodes: any[] = []

        for (let i = 0; i < JOB_PER_PAGE; i++) {
            jobListNodes.push(<JobItemPlaceholer key={i} />)
        }

        return (
            <JobItemPlaceholderStyles>
                <div className='job-list-placeholder animated fadeIn'>{jobListNodes}</div>
            </JobItemPlaceholderStyles>
        )
    }
}
